<template>
  <!-- 查看区域 -->
  <a-modal
    title="查看"
    :visible="viewVisible"
    @cancel="HandleCancel"
    @ok="HandleOk"
    width="1000px"
  >
    <p>分组名称:{{ this.group.groupName }}</p>
    <a-button
      class="exportBtn"
      :disabled="userDataListSelections.length == 0"
      @click="exportExcel"
      >批量导出</a-button
    >
    <a-button
      :disabled="userDataListSelections.length == 0"
      @click="handleUserDelete"
      >批量删除</a-button
    >
    <!--微信用户列表-->
    <a-table
      v-if="
        queryParam.channelCode == 'subscribe_wechat' ||
          queryParam.channelCode == 'h5_trade_service'
      "
      ref="table"
      :scroll="{ x: 1500 }"
      size="middle"
      :rowKey="record => record.openid"
      :columns="column"
      :dataSource="userList"
      :row-selection="{
        selectedRowKeys: userDataListSelections,
        onChange: userOnSelectChange
      }"
      class="j-table-force-nowrap"
      :pagination="ipagination"
      @change="handleTableChange"
      style="margin-top: 10px"
    >
      <template slot="headimgurlslot" slot-scope="text, record, index">
        <div class="anty-img-wrap">
          <a-avatar
            shape="square"
            :src="getHeadImageView(record.headimgurl)"
            icon="user"
          />
        </div>
      </template>
      <template slot="sexslot" slot-scope="text, record, index">
        <span v-if="record.sex === 1">男</span>
        <span v-if="record.sex === 2">女</span>
        <span v-if="record.sex === 0">未知</span>
      </template>
      <template slot="tagslot" slot-scope="text, record, index">
        <span>{{ getTagName(record.tagidList) }}</span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleUserDelete(record.openid)"
              >
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <!--小程序用户列表-->
    <a-table
      v-if="
        queryParam.channelCode == 'macroscopic_miniapp' ||
          queryParam.channelCode == 'integral_miniapp'
      "
      ref="table"
      :scroll="{ x: 1500 }"
      size="middle"
      :rowKey="record => record.id"
      :columns="columnMiniApp"
      :dataSource="userList"
      :row-selection="{
        selectedRowKeys: userDataListSelections,
        onChange: userOnSelectChange
      }"
      class="j-table-force-nowrap"
      :pagination="ipagination"
      @change="handleTableChange"
      style="margin-top: 10px"
    >
      <template slot="headimgurlslot" slot-scope="text, record, index">
        <div class="anty-img-wrap">
          <a-avatar
            shape="square"
            :src="getHeadImageView(record.avatarUrl)"
            icon="user"
          />
        </div>
      </template>
      <template slot="sexslot" slot-scope="text, record, index">
        <span v-if="record.gender === '1.0'">男</span>
        <span v-if="record.gender === '2.0'">女</span>
        <span v-if="record.gender === '0.0'">未知</span>
      </template>
    </a-table>
    <span slot="action" slot-scope="text, record">
      <a-dropdown>
        <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a-popconfirm
              title="确定删除吗?"
              @confirm="() => handleUserDelete(record.id)"
            >
              <a>删除</a>
            </a-popconfirm>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </span>
  </a-modal>
</template>
<script>
import {
  getAction,
  getFileAccessHttpUrl,
  downloadFiles,
  postAction
} from '@/api/manage';
export default {
  data() {
    return {
      channelInfo: {},
      userDataListSelections: [],
      userList: [],
      group: {},
      queryParam: {
        channelCode: ''
      },
      viewVisible: false,
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      column: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnMiniApp: [
        {
          title: 'openId',
          dataIndex: 'openId',
          align: 'center',
          key: 'openId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName',
          align: 'center',
          key: 'nickName'
        },
        {
          title: '头像',
          dataIndex: 'avatarUrl',
          align: 'center',
          key: 'avatarUrl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'gender',
          align: 'center',
          key: 'gender',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          align: 'center',
          key: 'phone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   fixed: 'right',
        //   width: 147,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    };
  },
  methods: {
    //获取图片
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    userOnSelectChange(selectedRowKeys) {
      this.userDataListSelections = selectedRowKeys;
      console.log(this.userDataListSelections);
    },
    //导出excel
    exportExcel() {
      let params = {
        type: this.channelInfo.type,
        userIds: this.userDataListSelections.join(',')
      };
      downloadFiles(
        process.env.VUE_APP_CMS_WECHAT +
          `/wechatUser/exportXls?userIds=${params.userIds}&type=${params.type}`,
        '用户信息.xls'
      ).then(res => {});
    },

    //查看弹框
    handView(record, queryParam, channelInfo) {
      this.queryParam = queryParam;
      this.channelInfo = channelInfo;
      this.viewVisible = true;
      this.userList = [];
      this.tagListAll = [];
      this.userDataListSelections = [];
      this.group = record;
      if (this.queryParam.channelCode == 'subscribe_wechat') {
        getAction(
          process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll',
          {
            appid: this.channelInfo.linkWechat
          }
        ).then(res => {
          if (res.success && res.code === 200) {
            this.tagListAll = res.result;
          } else {
            this.$message.error(res.message);
          }
        });
      }
      this.getList(1);
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.getList({
        pageNo: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    getList(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/viewList', {
        id: this.group.id,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }).then(res => {
        if (res.success & (res.result != null)) {
          this.userList = res.result.records;
          this.ipagination.total = res.result.total;
          console.log(res.result.records.length);
          this.loading = false;
        }
      });
    },
    handleUserDelete(id) {
      //删除数据
      if (this.userDataListSelections.length > 0) {
        id = this.userDataListSelections.join(',');
        console.log(id);
      }
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/deleteGroupUser',
        { groupId: this.group.id, userIds: id }
      )
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.viewVisible = false;
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {});
    },
    //modal取消
    HandleCancel(e) {
      this.viewVisible = false;
    },
    HandleOk(e) {
      this.viewVisible = false;
    }
  }
};
</script>
<style scoped>
.exportBtn {
  margin-right: 10px;
}
</style>
